module.exports = __webpack_public_path__ + "static/media/DignityHealth.715b8d51.png";